import React, {
  lazy,
  useRef,
  Suspense,
  useState,
  useEffect,
} from "react";
import Avatar from "react-avatar";
import { connect } from "react-redux";
import { useParams } from "react-router";
import { IoIosMenu } from "react-icons/io";
import { CgArrowLeft } from "react-icons/cg";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { array, func, object } from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Offcanvas } from "react-bootstrap";

import {
  emptyString,
  loginConstants,
  signalRConstants,
  LIST_PAGE_SIZE,
  PAGINATION_INDEXING,
  FIRST_ARRAY_INDEX,
  EMPTY_ARRAY_LENGTH,
  KEYBOARD_KEYS,
  inboxPageConstants,
  inboxReduxConstants,
  messageStatusEnumns,
  questionTypeConstants,
  defaultOpenAccordions,
  conversationStatusEnums,
  conversationFilters,
  conversationSubFilters,
  screenSize,
  featureFlagsEnums,
  STYLES,
} from "../../constants";

import {
  useSpinner,
  useWindowWidth,
  UTCToDateFormat,
  isSuperOrBrandAdmin,
  isSuperAdminWithRole,
  handleAsyncAction,
} from "../../../../shared";
import {
  sendData,
  useSignalR,
  addToBrandGroup,
  getItemFromStorage,
  updateConversation,
  removeFromBrandGroup,
  removeItemFromStorage,
} from "../../../../system";
import {
  inboxActions,
  groupsActions,
  brandProfileActions,
  individualGroupProfileActions,
} from "../../redux/actions";
import FilterComponent from "./shared/filterComponent";
import SearchComponent from "./shared/searchComponent";
import ConversationPanel from "./shared/conversationPanel";
import ConversationsSidebarList from "./shared/conversationsSidebarList";
import ConversationSubFilterComponent from "./shared/conversationSubFilterComponent";
import CustomerDetailSidebarComponent from "./shared/customerDetailSidebarComponent";
import FilterByResponseStatusComponent from "./shared/filterByResponseStatusComponent";
import useModalDisplay from "../../../../shared/components/hooks/useModalDisplay/useModalDisplay";
import useInboxFileUploads from "./hooks/useInboxFileUploads";
import useInboxAiResponses from "./hooks/useInboxAiResponses";
import useInboxSignalRListeners from "./hooks/useInboxSignalRListeners";
import { aiReplyActions } from "../../../admin-screens/redux/actions";

const AiReplyModal = lazy(
  () =>
    import("../../../../shared/components/popups/aiReplyPopup/aiReplyModal"),
);

const { TABLET, DESKTOP } = screenSize;
const { ENTER } = KEYBOARD_KEYS;

const {
  sendMessageconnectionKey,
  addToBrandGroupConnectionKey,
  updateConversationConnectionKey,
  removeFromBrandGroupConnectionKey,
} = signalRConstants;

const Inbox = (props) => {
  const {
    getGroups,
    imagePathFromHub,
    systemReducer: { allBrandsWithFeatureFlags },
    resetConversation,
    getAllConversations,
    resetAllConversations,
    inboxReducer: {
      allConversations,
      customerPreviewSurvey,
      previousConversationDates,
      conversation: {
        customerMessages,
        autoResponderStatus,
        customerInsights,
        orderDetails,
      },
      storeData,
      aiResponse,
    },
    getCustomerInsights,
    updateAllConversations,
    getConversationMessages,
    sendConversationMessage,
    getCustomerPreviewSurvey,
    getPreviousInternalNotes,
    getBrandLocationsByBrandId,
    getConversationOrderDetails,
    getBrandLocationsByGroupsIds,
    getPreviousConversationDates,
    authentication: { user },
    brandProfileReducer: { stores },
    resetPreviousConversationDates,
    getConversationByConversationId,
    updateCustomerConversationMessages,
    groupsReducer: { groups, allGroupLocations },
    resetAiResponse,
    generateAIResponse,
    reGenerateAIResponse,
    resetBrandSocialLinks,
  } = props;

  const localOrderId = getItemFromStorage(loginConstants.ORDER_ID);
  const localCustomerId = getItemFromStorage(loginConstants.CUSTOMER_ID);
  const localConversationId = getItemFromStorage(
    loginConstants.CONVERSATION_ID,
  );

  const isSuperAdmin = isSuperAdminWithRole(user.roleId);

  const signalRContext = useSignalR();

  const { brandId } = useParams();

  const firstRender = useRef(true);
  const inputFieldRef = useRef();
  const fileUploaderRef = useRef();
  const chatAreaRef = useRef(null);
  const isGroupChangedRef = useRef(false);

  const { files, setFiles, handleFileChange } = useInboxFileUploads();

  const [showChat, setShowChat] = useState(false);
  const windowWidth = useWindowWidth();
  const [queryParams, setQueryParams] = useState({
    pageNumber: PAGINATION_INDEXING.FIRST_PAGE_INDEX,
    length: LIST_PAGE_SIZE,
    filter: emptyString,
    search: emptyString,
  });
  const [isSending, setIsSending] = useState(false);
  const [message, setMessage] = useState(emptyString);
  const [selectedChat, setSelectedChat] = useState([]);
  const [selectedStores, setSelectedStores] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [inputMessage, setInputMessage] = useState(emptyString);
  const [selectedConversation, setSelectedConversation] = useState({});
  const [allCustomerConversation, setAllCustomerConversation] = useState([
    ...allConversations,
  ]);

  const [showDetails, setShowDetails] = useState(true);
  const [activeKeys, setActiveKeys] = useState(defaultOpenAccordions);
  const [showOffCanvas, setShowOffCanvas] = useState(false);
  const [conversationStatusFilter, setConversationStatusFilter] = useState(
    conversationFilters[FIRST_ARRAY_INDEX],
  );
  const [conversationSubFilter, setConversationSubFilter] = useState(
    conversationSubFilters[FIRST_ARRAY_INDEX],
  );
  const [groupCreated, setGroupCreated] = useState(false);
  const [isAIGenerationButtonVisible, setIsAIGenerationButtonVisible] =
    useState(false);

  const queryParamsRef = useRef(queryParams);
  const selectedGroupsRef = useRef(selectedGroups);
  const selectedStoresRef = useRef(selectedStores);

  const [showConfirmationModal, confirmationModalElement] = useModalDisplay();

  //Conversation is selected or not
  const isConversationSelected =
    Object.keys(selectedConversation).length > EMPTY_ARRAY_LENGTH;

  //Current brand id
  const currentBrandId = () => {
    if (isSuperOrBrandAdmin()) {
      return brandId;
    } else {
      return user.brandId;
    }
  };

  // Show loading while a request is running.
  const spinner = useSpinner();

  //Is Spinner running
  const isSpinnerRunning = () =>
    spinner(inboxReduxConstants.GET_CONVERSATION_MESSAGES);

  //Handle Select emoji
  const handleEmojiClick = (event) => {
    //Get the current cursor position
    const cursorPosition = inputFieldRef.current.selectionStart;

    //Insert the emoji at the cursor position
    const newMessage = `${inputMessage.slice(
      FIRST_ARRAY_INDEX,
      cursorPosition,
    )}${event}${inputMessage.slice(cursorPosition)}`;

    //Update the message state
    setInputMessage(newMessage);
  };

  //Handle conversation click
  const handleConversationClick = (conv, conversationId, orderId) => {
    setSelectedChat([]);
    resetConversation();
    setShowDetails(true);
    setActiveKeys(defaultOpenAccordions);
    getCustomerPreviewSurvey(conversationId || conv.id);
    getCustomerInsights(currentBrandId(), conv?.customerId);
    getConversationOrderDetails(conversationId || conv.id);

    if ((conv?.hasUnreadMessages || conv?.isNew) && !isSuperAdmin) {
      updateConversation({
        connection: signalRContext?.connection,
        conversationId: Number(conversationId || conv.id),
        connectionKey: updateConversationConnectionKey,
      });
    }

    setIsAIGenerationButtonVisible(false);

    setSelectedConversation({
      ...conv,
      ...(orderId && {
        orderId: orderId,
      }),
    });

    getConversationMessages(conversationId, conv);
    setShowChat(true);
    setInputMessage(emptyString);
    setFiles([]);
    scrollToBottom();
  };

  useEffect(() => {
    const allTextQuestionsHaveEmptyAnswers = customerPreviewSurvey.responseJson
      ?.filter(
        (question) =>
          question.questionTypeId === questionTypeConstants.TEXTBOX_ID,
      )
      .every((question) => question.answer === emptyString);

    const shouldButtonShow = !(
      selectedConversation.conversationStatus ===
        conversationStatusEnums.POSITIVE && allTextQuestionsHaveEmptyAnswers
    );

    setIsAIGenerationButtonVisible(shouldButtonShow);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerPreviewSurvey]);

  //Handle change in message field
  const handleMessageChange = (e) => {
    const { key, target } = e;
    if (key === ENTER) {
      setMessage(`${target.value} \n `);
    } else {
      setMessage(target.value);
    }
  };

  const handleInputMessageChange = (e) => {
    const { key, target } = e;
    if (key === ENTER) {
      setInputMessage(`${target.value} \n `);
    } else {
      setInputMessage(target.value);
    }
  };

  //Calculate the page number
  const calculatePageNumber = (length) =>
    Math.floor(length / LIST_PAGE_SIZE);

  //Get more conversation on scroll
  const getConversations = (
    isScroll = true,
    callbackFunc = () => {},
    updatedParams = null,
    updatedGroups = null,
    updatedStores = null,
  ) => {
    getAllConversations(
      {
        ...(updatedParams || queryParams),
        ...(isScroll && {
          pageNumber: calculatePageNumber(allCustomerConversation.length),
        }),
      },
      {
        brandId: currentBrandId(),
        groupIds: [...(updatedGroups || selectedGroups)].map(
          (group) => group.id,
        ),
        storeIds: isGroupChangedRef.current
          ? []
          : [...(updatedStores || selectedStores)].map((store) => store.id),
      },
      callbackFunc,
    );
  };
  //Scroll to bottom
  const scrollToBottom = () => {
    if (chatAreaRef.current) {
      chatAreaRef.current.scrollTop = chatAreaRef.current.scrollHeight;
    }
  };

  //Update conversation with signalR
  const updateData = (data) => {
    sendConversationMessage(data, user);
  };

  //Update all conversation array with signalR
  const updateAllConversationArray = (data) => {
    updateAllConversations(data);
  };

  //Extract plan text base64 from images
  const extractBase64 = () => {
    return files.map((file) => {
      return {
        contentType: file.contentType,
        attachment: file.attachment.split(",")[1],
      };
    });
  };

  //Send message to server using signalR
  const sendMessage = async (isAiGenerated = false) => {
    const newMessage = inputMessage || message;
    sendData({
      connection: signalRContext?.connection,
      connectionKey: sendMessageconnectionKey,
      data: {
        message: newMessage,
        customerConversationIds: [selectedConversation.id],
        messageAttachments: extractBase64(),
        systemUserName: user.name,
        systemUserId: user.id,
        isAiGenerated: isAiGenerated,
      },
      setIsSending,
      resetFields: () => {
        setMessage(emptyString);
        setInputMessage(emptyString);
        setFiles([]);
        resetAiResponse();
        resetBrandSocialLinks();
      },
    });
  };

  const {
    isOpen,
    generateAiResponse,
    reGenerateAiResponse,
    handleSendMessageAndToggleModal,
    handleCloseModalAndResetFields,
  } = useInboxAiResponses({
    aiResponse,
    selectedConversation,
    generateAIResponse,
    reGenerateAIResponse,
    resetAiResponse,
    resetBrandSocialLinks,
    sendMessage,
    setInputMessage,
    setFiles,
    setMessage,
  });

  //Add brand to group when route to inbox screen
  const addBrandToGroup = () => {
    addToBrandGroup({
      connection: signalRContext?.connection,
      connectionKey: addToBrandGroupConnectionKey,
      data: currentBrandId().toString(),
      setGroupCreated,
    });
  };

  //Remove brand from group when leaving inbox page
  const removeBrandGroup = () => {
    removeFromBrandGroup({
      connection: signalRContext?.connection,
      connectionKey: removeFromBrandGroupConnectionKey,
      setGroupCreated,
    });
  };

  //Function to handle change in conversation status filter and conversation subfilter
  const applyDynamicFilter = () => {
    let filterQuery = emptyString;

    //If both status filter and sub filter applies, then combine both with AND, & setQueryParams
    if (conversationStatusFilter.value && conversationSubFilter.value) {
      filterQuery = `${conversationStatusFilter.value} AND ${conversationSubFilter.value}`;
    }

    //If status filter apply and conversation filter is empty, then set filter query with only status filter
    if (conversationStatusFilter.value && !conversationSubFilter.value) {
      filterQuery = conversationStatusFilter.value;
    }

    //If sub filter apply and conversation status filter is empty, then set filter query with only sub filter filter
    if (!conversationStatusFilter.value && conversationSubFilter.value) {
      filterQuery = conversationSubFilter.value;
    }

    //Update query params with the modified filter string
    setQueryParams({
      ...queryParams,
      filter: filterQuery,
    });
  };

  const getFilterStoresForFilterComponent = () => {
    if (selectedGroups.length || !isSuperOrBrandAdmin()) {
      return allGroupLocations;
    } else {
      return stores;
    }
  };

  const resetChatState = () => {
    setShowChat(false);
    setSelectedConversation({});
  };

  //Function to check if AI Reply is active
  const isAIReplyActive = () => {
    return (
      allBrandsWithFeatureFlags.length > EMPTY_ARRAY_LENGTH &&
      allBrandsWithFeatureFlags?.some((brand) => {
        return (
          Number(brand.brandId) === Number(currentBrandId()) &&
          brand.stores?.some(
            (store) =>
              store.storeId === storeData?.storeId &&
              store.storeFeatures?.includes(featureFlagsEnums.AI_REPLY),
          )
        );
      })
    );
  };

  //Get conversation data on basis of filter
  useEffect(() => {
    applyDynamicFilter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conversationStatusFilter.value, conversationSubFilter.value]);

  //Get conversation data
  useEffect(() => {
    queryParamsRef.current = queryParams;

    getConversations(false, resetAllConversations);

    //Reset All conversation on component unmount
    resetChatState();
    return () => {
      resetAllConversations();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams, selectedGroups]);

  //Get conversation data
  useEffect(() => {
    //Stop default first time render
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

    resetChatState();
    selectedStoresRef.current = selectedStores;

    if (!isGroupChangedRef.current) {
      getConversations(false, resetAllConversations);
      //Reset All conversation on component unmount
      return () => {
        resetAllConversations();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStores]);

  //Update conversation messages
  useEffect(() => {
    setSelectedChat(customerMessages);
    const unreadMessages = customerMessages?.filter(
      (conv) => conv?.chatStatusId === messageStatusEnumns.UNREAD,
    );

    if (showChat && unreadMessages.length && !isSuperAdmin) {
      updateConversation({
        connection: signalRContext?.connection,
        conversationId: selectedConversation.id,
        connectionKey: updateConversationConnectionKey,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerMessages]);

  //Scroll to bottom if chat open
  useEffect(() => {
    scrollToBottom();
  }, [selectedChat, showChat, customerMessages]);

  useInboxSignalRListeners({
    connection: signalRContext?.connection,
    connectionState:
      signalRContext?.connection?._connectionState ??
      signalRContext?.connection?.state,
    connectionId: signalRContext?.connection?.connectionId,
    groupCreated,
    addBrandToGroup,
    removeBrandGroup,
    onReceiveMessage: updateData,
    onNewConversation: updateAllConversationArray,
    onConversationUpdated: updateCustomerConversationMessages,
  });

  //Select default conversation when route from mail
  useEffect(() => {
    setAllCustomerConversation(allConversations);
    if (
      localOrderId &&
      localCustomerId &&
      localConversationId &&
      allConversations.length
    ) {
      const filteredConversation = allConversations.find(
        (conv) => conv.customerId === Number(localCustomerId),
      );

      //Conversation is in first page then select other wise get conversation by conversation id.
      if (groupCreated) {
        if (filteredConversation) {
          handleConversationClick(
            filteredConversation,
            localConversationId,
            localOrderId,
          );
        } else {
          handleAsyncAction(getConversationByConversationId(localConversationId), {
            onSuccess: (response) => {
              handleConversationClick(
                response,
                localConversationId,
                localOrderId,
              );
            },
          });
        }
        removeItemFromStorage(loginConstants.ORDER_ID);
        removeItemFromStorage(loginConstants.CUSTOMER_ID);
        removeItemFromStorage(loginConstants.CONVERSATION_ID);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localCustomerId, allConversations, groupCreated]);

  useEffect(() => {
    selectedGroupsRef.current = selectedGroups;

    if (selectedGroups.length) {
      getBrandLocationsByGroupsIds(selectedGroups.map((group) => group.id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedGroups]);

  //Get stores by selected groups
  useEffect(() => {
    if (!isSuperOrBrandAdmin() && groups?.data?.length) {
      getBrandLocationsByGroupsIds(groups?.data.map((group) => group.id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groups]);

  //Start connection to signalR / load groups & locations
  useEffect(() => {
    getGroups(isSuperOrBrandAdmin() ? brandId : user?.brandId);
    if (isSuperOrBrandAdmin()) {
      getBrandLocationsByBrandId(brandId);
    }

    return () => {
      resetAllConversations();
      resetConversation();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isAIReplyActive() && (
        <Suspense fallback={<div>Loading ai reply modal</div>}>
          <AiReplyModal
            isOpen={isOpen}
            spinner={spinner}
            message={message}
            isSending={isSending}
            isSuperAdmin={isSuperAdmin}
            generateAiResponse={reGenerateAiResponse}
            handleMessageChange={handleMessageChange}
            selectedConversation={selectedConversation}
            sendMessage={handleSendMessageAndToggleModal}
            isOpenToggle={handleCloseModalAndResetFields}
            brandId={isSuperOrBrandAdmin() ? brandId : user?.brandId}
          />
        </Suspense>
      )}
      <div className="d-flex flex-column position-relative">
        {showConfirmationModal && confirmationModalElement}
        <FilterComponent
          ref={isGroupChangedRef}
          groups={groups}
          showChat={showChat}
          windowWidth={windowWidth}
          setShowChat={setShowChat}
          queryParams={queryParams}
          selectedGroups={selectedGroups}
          selectedStores={selectedStores}
          setQueryParams={setQueryParams}
          setSelectedChat={setSelectedChat}
          setSelectedGroups={setSelectedGroups}
          setSelectedStores={setSelectedStores}
          resetAllConversations={resetAllConversations}
          setSelectedConversation={setSelectedConversation}
          stores={getFilterStoresForFilterComponent()}
        />

        <div
          className={`d-flex align-items-stretch rounded-4 container-fluid px-0`}
        >
          <aside
            className={`bg-white border border-top overflow-hidden d-flex flex-column inbox-sidebar ${
              windowWidth <= DESKTOP ? "w-100" : "min-w-30"
            } ${showChat && windowWidth <= DESKTOP && STYLES.D_NONE}`}
          >
            <SearchComponent
              setShowChat={setShowChat}
              queryParams={queryParams}
              setQueryParams={setQueryParams}
            />
            <FilterByResponseStatusComponent
              applyDynamicFilter={applyDynamicFilter}
              selectedFilter={conversationStatusFilter}
              setSelectedFilter={setConversationStatusFilter}
            />
            <ConversationSubFilterComponent
              applyDynamicFilter={applyDynamicFilter}
              selectedFilter={conversationSubFilter}
              setSelectedFilter={setConversationSubFilter}
              isSpinnerRunning={
                spinner(inboxReduxConstants.GET_ALL_CONVERSATIONS)
              }
              refresh={() => getConversations(false, resetAllConversations)}
              imagePathFromHub={imagePathFromHub}
            />
            <div
              className="overflow-auto custome-sidebar h-100"
              id="inbox-sidebar"
              data-testid="inbox-sidebar"
            >
              <ConversationsSidebarList
                spinner={spinner}
                getConversations={getConversations}
                selectedConversation={selectedConversation}
                allCustomerConversation={allCustomerConversation}
                onConversationClick={handleConversationClick}
              />
            </div>
          </aside>
          <main
            className={`flex flex-column border bg-white ms-auto overflow-hidden inbox-main w-100 ${
              !showChat && windowWidth <= DESKTOP && STYLES.D_NONE
            }`}
            data-testid="inbox-main"
          >
            <div
              className="inbox-main-header d-flex justify-content-between gap-2 align-items-center border-bottom border-1 py-2 ps-md-3 px-2"
              data-testid="inbox-main-header"
            >
              {isConversationSelected && !isSpinnerRunning() && (
                <>
                  <div className="d-flex align-items-center gap-2">
                    {windowWidth <= DESKTOP && (
                      <span className="fw-normal">
                        <CgArrowLeft
                          size={30}
                          className="pointer"
                          role="button"
                          title="Hide chat"
                          onClick={() => {
                            setShowChat(false);
                            setSelectedConversation({});
                          }}
                        />
                      </span>
                    )}
                    <div className="text-start lh-1">
                      <div className="d-flex align-items-center gap-2">
                        <Avatar
                          round
                          size="45"
                          className="fw-bolder"
                          name={selectedConversation.customerName}
                        />
                        <div className="d-flex flex-column justify-content-between h-100">
                          <h6
                            className={`customer-name text-truncate ${
                              windowWidth > TABLET
                                ? "text-truncate-13ch"
                                : "text-truncate-17ch"
                            }`}
                            title={selectedConversation?.customerName}
                            data-testid="customer-name"
                          >
                            {selectedConversation?.customerName}
                          </h6>
                          <small
                            className="bold-6 opacity-50 mb-md-0 mb-1"
                            title="Survey Completion"
                          >
                            Survey Completion:{" "}
                            {UTCToDateFormat(
                              selectedConversation.surveyCompletionDate,
                            )}
                          </small>
                          <div className="d-md-none">
                            {autoResponderStatus && (
                              <small className="mb-0 align-self-end">
                                <span className="bold-6 opacity-50">
                                  {autoResponderStatus.triggerType} Winback{" "}
                                  {autoResponderStatus.status}:
                                </span>{" "}
                                <span className="opacity-50">
                                  {UTCToDateFormat(
                                    autoResponderStatus.updatedAt,
                                  )}
                                </span>
                              </small>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex align-items-center gap-2 h-100">
                    <div className="d-md-flex d-none align-self-end">
                      {autoResponderStatus && (
                        <small className="mb-0">
                          <span className="bold-6 opacity-50">
                            {autoResponderStatus.triggerType} Winback{" "}
                            {autoResponderStatus.status}:
                          </span>{" "}
                          <span className="opacity-50">
                            {UTCToDateFormat(autoResponderStatus.updatedAt)}
                          </span>
                        </small>
                      )}
                    </div>
                    <div>
                      {!showDetails && windowWidth >= DESKTOP && (
                        <IoIosMenu
                          size={30}
                          role="button"
                          title="See customer Details"
                          onClick={() => setShowDetails(true)}
                        />
                      )}
                      {!showOffCanvas && windowWidth <= DESKTOP && (
                        <IoIosMenu
                          size={30}
                          role="button"
                          title="See customer Details"
                          onClick={() => setShowOffCanvas(true)}
                        />
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="inbox-chat-area">
              <ConversationPanel
                user={user}
                files={files}
                spinner={spinner}
                showChat={showChat}
                setFiles={setFiles}
                isSending={isSending}
                setMessage={setMessage}
                sendMessage={sendMessage}
                selectedChat={selectedChat}
                chatAreaRef={chatAreaRef}
                orderDetails={orderDetails}
                inputMessage={inputMessage}
                localCustomerId={localCustomerId}
                isSuperAdmin={isSuperAdmin}
                fileUploaderRef={fileUploaderRef}
                inputFieldRef={inputFieldRef}
                showEmojiPicker={showEmojiPicker}
                isAIReplyActive={isAIReplyActive}
                handleFileChange={handleFileChange}
                handleEmojiClick={handleEmojiClick}
                setShowEmojiPicker={setShowEmojiPicker}
                generateAiResponse={generateAiResponse}
                customerPreviewSurvey={customerPreviewSurvey}
                selectedConversation={selectedConversation}
                handleInputMessageChange={handleInputMessageChange}
                isConversationSelected={isConversationSelected}
                isAIGenerationButtonVisible={isAIGenerationButtonVisible}
              />
            </div>
          </main>
          {/* Customer Detail Sidebar */}
          {showDetails && showChat && windowWidth > DESKTOP && (
            <aside className="bg-white border border-top overflow-hidden d-flex flex-column inbox-sidebar min-w-25 customer-details-sidebar">
              <div className="py-2 px-3 border-1 border-bottom d-flex align-items-center justify-content-between inbox-sidebar-header">
                <h5 className="fw-bold mb-0">Details</h5>
                <div>
                  <FontAwesomeIcon
                    size="xl"
                    role="button"
                    icon={faTimes}
                    className="pointer"
                    onClick={() => setShowDetails(false)}
                    title="Hide customer details"
                  />
                </div>
              </div>
              <CustomerDetailSidebarComponent
                user={user}
                spinner={spinner}
                activeKeys={activeKeys}
                setMessage={setMessage}
                setInputMessage={setInputMessage}
                brandId={currentBrandId()}
                queryParams={queryParams}
                setActiveKeys={setActiveKeys}
                selectedGroups={selectedGroups}
                selectedStores={selectedStores}
                customerInsights={customerInsights}
                selectedConversation={selectedConversation}
                customerPreviewSurvey={customerPreviewSurvey}
                setSelectedConversation={setSelectedConversation}
                getConversationMessages={getConversationMessages}
                getCustomerPreviewSurvey={getCustomerPreviewSurvey}
                getPreviousInternalNotes={getPreviousInternalNotes}
                previousConversationDates={previousConversationDates}
                getConversationOrderDetails={getConversationOrderDetails}
                getPreviousConversationDates={getPreviousConversationDates}
                resetPreviousConversationDates={resetPreviousConversationDates}
              />
            </aside>
          )}

          <Offcanvas
            placement="end"
            show={showOffCanvas}
            onHide={() => setShowOffCanvas(false)}
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title className="fw-bold">Details</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <CustomerDetailSidebarComponent
                user={user}
                spinner={spinner}
                activeKeys={activeKeys}
                setMessage={setMessage}
                setInputMessage={setInputMessage}
                brandId={currentBrandId()}
                queryParams={queryParams}
                setActiveKeys={setActiveKeys}
                selectedGroups={selectedGroups}
                selectedStores={selectedStores}
                customerInsights={customerInsights}
                setShowOffCanvas={setShowOffCanvas}
                selectedConversation={selectedConversation}
                customerPreviewSurvey={customerPreviewSurvey}
                setSelectedConversation={setSelectedConversation}
                getConversationMessages={getConversationMessages}
                getCustomerPreviewSurvey={getCustomerPreviewSurvey}
                getPreviousInternalNotes={getPreviousInternalNotes}
                previousConversationDates={previousConversationDates}
                getConversationOrderDetails={getConversationOrderDetails}
                getPreviousConversationDates={getPreviousConversationDates}
                resetPreviousConversationDates={resetPreviousConversationDates}
              />
            </Offcanvas.Body>
          </Offcanvas>
        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state) => ({
  systemReducer: state.system,
  inboxReducer: state.inboxReducer,
  groupsReducer: state.groupsReducer,
  authentication: state.authentication,
  brandProfileReducer: state.brandProfileReducer,
  imagePathFromHub: state.system.fromHub?.imagePath,
  individualGroupProfileReducer: state.individualGroupProfileReducer,
});

const mapDispatchToProps = (dispatch) => ({
  getAllConversations: (params, body, resetAllConversations) =>
    dispatch(
      inboxActions.getAllConversations(params, body, resetAllConversations),
    ),
  sendConversationMessage: (data, loggedUser) =>
    dispatch(inboxActions.sendConversationMessage(data, loggedUser)),
  updateAllConversations: (data) =>
    dispatch(inboxActions.updateAllConversations(data)),
  getConversationMessages: (conversationId, conv) =>
    dispatch(inboxActions.getConversationMessages(conversationId, conv)),
  updateCustomerConversationMessages: (convId) =>
    dispatch(inboxActions.updateConversation(convId)),
  resetConversation: () => dispatch(inboxActions.resetConversation()),
  resetAllConversations: () => dispatch(inboxActions.resetAllConversations()),
  getGroups: (brandId) => dispatch(groupsActions.getGroups(brandId)),
  getBrandLocationsByGroupsIds: (groupIds) =>
    dispatch(
      individualGroupProfileActions.getBrandLocationsByGroupsIds(groupIds),
    ),
  getBrandLocationsByBrandId: (brandId) =>
    dispatch(brandProfileActions.getBrandLocationsByBrandId(brandId)),
  getCustomerPreviewSurvey: (conversationId) =>
    dispatch(inboxActions.getCustomerPreviewSurvey(conversationId)),
  getPreviousConversationDates: (body) =>
    dispatch(inboxActions.getPreviousConversationDates(body)),
  resetPreviousConversationDates: () =>
    dispatch(inboxActions.resetPreviousConversationDates()),
  resetAiResponse: () => dispatch(inboxActions.resetAiResponse()),
  resetBrandSocialLinks: () => dispatch(aiReplyActions.resetBrandSocialLinks()),
  getPreviousInternalNotes: (orderId) =>
    dispatch(inboxActions.getPreviousInternalNotes(orderId)),
  getCustomerInsights: (brandId, customerId) =>
    dispatch(inboxActions.getCustomerInsights(brandId, customerId)),
  getConversationByConversationId: (conversationId) =>
    dispatch(inboxActions.getConversationByConversationId(conversationId)),
  getConversationOrderDetails: (conversationId) =>
    dispatch(inboxActions.getConversationOrderDetails(conversationId)),
  generateAIResponse: (conversationId) =>
    dispatch(inboxActions.generateAIResponse(conversationId)),
  reGenerateAIResponse: (responseAction, conversationId) =>
    dispatch(inboxActions.reGenerateAIResponse(responseAction, conversationId)),
});

//Validate props types
Inbox.propTypes = {
  user: object,
  inboxReducer: object,
  conversation: object,
  authentication: object,
  allConversations: array,
  resetConversation: func,
  customerMessages: array,
  getAllConversations: func,
  resetAllConversations: func,
  getConversationMessages: func,
  sendConversationMessage: func,
  updateCustomerConversationMessages: func,
};

export default connect(mapStateToProps, mapDispatchToProps)(Inbox);
